import Axios from 'axios';
import { useMutation } from '@tanstack/vue-query';

export default function useWishlistToggleMutation(onSuccess) {
  return useMutation({
    mutationFn: ({ productId, wished }) => (wished
      ? Axios.delete(`/api/account/wishlist/${productId}`)
      : Axios.post(`/api/account/wishlist/${productId}`)),
    onSuccess,
  });
}
